import {
  Swiper,
  Navigation,
  Pagination,
  Scrollbar,
} from 'swiper';
import type { SwiperOptions } from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
  Scrollbar,
]);

const init = (slider: HTMLElement) => {
  // Default options for each swiper instance
  const defaultOptions: SwiperOptions = {
    loop: true,
    speed: 500,
    autoHeight: true,
    keyboard: true,

    slideActiveClass: 'slider__slide--active',

    pagination: {
      el: slider.querySelector('.slider__pagination') as HTMLElement,
      modifierClass: 'slider__pagination--',
      bulletClass: 'slider__bullet',
      bulletActiveClass: 'slider__bullet--active',
      clickable: true,
      clickableClass: 'slider__pagination--clickable',
    },

    navigation: {
      nextEl: slider.querySelector('.slider__button--next') as HTMLElement,
      prevEl: slider.querySelector('.slider__button--prev') as HTMLElement,
      disabledClass: 'slider__button--disabled',
    },

    scrollbar: {
      el: slider.querySelector('.slider__scrollbar') as HTMLElement,
    },
  };

  // If slider has custom options combine them and create
  // Swiper instance, otherwise create Swiper instance with
  // default options (custom overwrites default)
  const extendedOptions: SwiperOptions = JSON.parse(decodeURIComponent(slider.getAttribute('data-swiper')));

  return new Swiper(slider, { ...defaultOptions, ...extendedOptions });
};

export default init;
